import { createSlice, Dispatch, PayloadAction } from "@reduxjs/toolkit";
import { client } from "../App";
import { LoadingErrorType } from "../helpers/enums";
import { CONTRACT_DETAIL } from "../helpers/queries";
import { ContractDetailReq, InvoicesReq } from "../models/Contract";
import { RootState } from "../rootReducer";
import { AppDispatch } from "../store";
import { hideLoading, showLoading } from "./app";
import { setLoadingError } from "./auth";

const initialState: any = {
  contractSelected: {
    id: null,
    name: null,
    state: null,
    bill: {},
    usage: {},
  },
};

const usageDataState = createSlice({
  name: "usageData",
  initialState,
  reducers: {
    setContract(state, action: PayloadAction<any | null>): void {
      state.contractSelected = action.payload;
    },
    resetData(state, action: PayloadAction<any | null>): void {
      state.contractSelected = {};
    },
  },
});

export const { setContract, resetData } = usageDataState.actions;
export default usageDataState.reducer;

export function resetContractSelected() {
  return async function (dispatch: Dispatch, getState: any) {
    dispatch(resetData(getState()));
  };
}

const requestContract = (contract: any) => {
  return client()
    .query({
      query: CONTRACT_DETAIL,
      variables: { ...ContractDetailReq(contract.id), ...InvoicesReq(true) },
      fetchPolicy: "network-only",
    })
    .then((response: any) => {
      console.log("response: ", response);

      const elements = response?.data?.contractDetail?.invoices?.elements ?? [];
      const [bill] = elements;

      console.log(bill, "<----- bill");

      let updateContract = {
        ...contract,
        bill: bill || null,
        usage: [],
      };

      return updateContract;
    })
    .catch((error: any) => {
      console.error("Errore in requestContract:", error);
      return null;
    });
};

export function setDefaultSelectedContract(dispatch: Dispatch, contract: any) {
  return async function (dispatch: Dispatch) {
    try {
      const cc = await requestContract(contract);
      console.log("#### contract ", cc);

      return contract ? dispatch(setContract(cc)) : null;
    } catch (e) {
      console.log(e);
      dispatch<any>(hideLoading());
    }
  };
}

export function setContractSelected(id: string) {
  return async function (dispatch: AppDispatch, getState: () => RootState) {
    try {
      dispatch(showLoading());

      const { contracts } = getState().auth;

      const [contract] = contracts.filter((ele: any) => {
        return ele.id === id;
      });

      if (contract) {
        const cc = await requestContract(contract);

        dispatch(hideLoading());

        return dispatch(setContract(cc));
      }

      return null;
    } catch (e) {
      console.log(e);

      const networkErrors = (e as any)?.networkError?.result?.errors ?? [];
      const errors = networkErrors.map((error: any) => error?.extensions?.code);

      if (errors.length > 0) {
        dispatch(setLoadingError(LoadingErrorType.CannotGetBills));
      }
    }
  };
}
